import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import router from './router';

import 'bootstrap-vue/dist/bootstrap-vue.css';

import './assets/css/i-con.css';
import './assets/css/theme.css';

import CKEditor from '@ckeditor/ckeditor5-vue';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VeeValidate from 'vee-validate';
import vueDebounce from 'vue-debounce';
import store from './store';

import moment from 'vue-moment';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faBold, faItalic, faTrash, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { mapGetters, mapState } from 'vuex';
import Loader from './components/Loader';
import { AUTHORS_REQUEST } from '@/store/actions/authors';
import { LAWYERS_REQUEST } from '@/store/actions/lawyers';
import { AUTH_LOGOUT } from '@/store/actions/auth';
import { BOOKS_REQUEST } from '@/store/actions/books';
import { CATEGORIES_REQUEST } from '@/store/actions/categories';
import { PUBLISHERS_REQUEST } from '@/store/actions/publishers';
import { STATS_REQUEST } from '@/store/actions/stats';


/**
 * Image uploader
 */
import ImageUploader from 'vue-image-upload-resize'
Vue.use(ImageUploader);

/**
 * i18n
 */
import { i18n } from '@/lang/config.js';

// Datepicker
import Datepicker from 'vuejs-datepicker';
Vue.component('datepicker', Datepicker);

library.add(faBold, faItalic, faTrash, faCheck);

Vue.component('font-awesome-icon', FontAwesomeIcon);


const startWithHttp = {

  validate (value) {

    if (value && (value.startsWith('http://') || value.startsWith('https://'))) {
      return true
    }

    return false;
  },

  getMessage() {
    return 'Links müssen mit http:// oder https:// beginnen';
  },
};

VeeValidate.Validator.extend('force-http-prefix', startWithHttp);

Vue.use(CKEditor)
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VeeValidate, {fieldsBagName: 'veeFields'})
Vue.use(vueDebounce)
Vue.use(moment)

/**
 * Sweetalert2
 */
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.config.productionTip = false;

/**
 * Firestore
 */
import firebase from 'firebase/app';
const firebase_config = require(process.env.VUE_APP_FIREBASE_CREDITENTIALS);
firebase.initializeApp(firebase_config);

if (process.env.VUE_APP_LOCAL_DEBUG) {
  const db = firebase.firestore();

  db.settings({
    host: "localhost:8080",
    ssl: false
  });

  firebase.functions().useFunctionsEmulator("http://localhost:5001");
}

/**
 * Mixins
 */
Vue.mixin({
  data() {
    return {
      storageBaseLink: process.env.VUE_APP_STORAGE_BASE_LINK,
    }
  },
  computed: {
    ...mapState({
      dataLoading: state => state.guidelines.status === 'loading',
      // dataError: state => state.guidelines.status === 'error',
      // dataEmpty: state => state.guidelines.status === 'empty',
    }),
    ...mapGetters([
      'authors',
      'authorsLoaded',
      'backups',
      'backupsLoaded',
      'backupsLoading',
      'books',
      'booksLoaded',
      'booksLoading',
      'categories',
      'categoriesLoaded',
      'configuration',
      'configurationLoading',
      'impressum',
      'impressumLoaded',
      'impressumLoading',
      'isAuthenticated',
      'lawyers',
      'lawyersLoaded',
      'publishers',
      'publishersLoaded',
      'slider',
      'sliderLoading',
      'stats',
      'statsLoaded',
    ]),

    version() {
      return process.env.VUE_APP_VERSION;
    },
  },
  components: {
    Loader
  },
  methods: {
    handleUnauth(status) {
      if (status == 401) {
        this.$store.dispatch(AUTH_LOGOUT);
        this.$router.go('/');
      }
    },

    handleForbidden(status) {
      if (status == 403) {
        this.$swal({
          title: this.$t("message.forbidden"),
          text: this.$t("message.thisActionIsForbidden"),
          type: 'warning',
          showCancelButton: false,
        })
      }
    },

    handleUnprocessable(response) {
      if (response.status == 422) {
        let message = response.data.message;

        for (let x in response.data.errors) {
          message += '<br>' + response.data.errors[x];
        }

        this.$swal({
          title: this.$t("message.unprocessable"),
          html: message,
          type: 'warning',
          showCancelButton: false,
        })
      }
    },

    logout() {
      this.$store.dispatch('AUTH_LOGOUT').then(() => {
        this.$router.push('/login')
      })
    },

    /**
     * [inputFilter for file uploader]
     * @param  {[type]} newFile [description]
     * @param  {[type]} oldFile [description]
     * @param  {[type]} prevent [description]
     * @return {[type]}         [description]
     */
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files

        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
  },

  beforeRouteEnter (to, from, next) {
    if (store.getters.isAuthenticated) {
      store.dispatch(AUTHORS_REQUEST).then(() => {
      })

      store.dispatch(BOOKS_REQUEST);

      store.dispatch(STATS_REQUEST);

      store.dispatch(CATEGORIES_REQUEST);

      store.dispatch(PUBLISHERS_REQUEST);

      store.dispatch(LAWYERS_REQUEST);
    }
    
    next()
  }
})

new Vue({
  render: h => h(App),
  router,
  store,
  i18n,
}).$mount('#app');
